﻿import request from '@/config/axios'

export interface BannerVO {
  id?: number
  title?: string
  imageUrl: string
  sort?: number
  status: number
  createTime?: Date
  remark?: string
}

export type BannerVo = BannerVO

export const BannerApi = {
  getList: (params: any) => {
    return request.get({ url: '/portal-ops/banner/page', params })
  },
  /** 公开列表：仅启用项，供工作台首页展示 */
  getPublicList: (params?: any) => {
    return request.get({
      url: '/portal-ops/banner/public-page',
      params: { pageNo: 1, pageSize: 20, status: 0, ...(params || {}) }
    })
  },
  get: (id: number) => {
    return request.get({ url: '/portal-ops/banner/get?id=' + id })
  },
  create: (data: BannerVO) => {
    return request.post({ url: '/portal-ops/banner/create', data })
  },
  update: (data: BannerVO) => {
    return request.put({ url: '/portal-ops/banner/update', data })
  },
  delete: (id: number) => {
    return request.delete({ url: '/portal-ops/banner/delete?id=' + id })
  }
}
